(() => {
  if (window.__SectionRenderPdpInitialized) return;
  window.__SectionRenderPdpInitialized = true;

  function docFrom(html) {
    return new DOMParser().parseFromString(html, "text/html");
  }

  function runScripts(container) {
    const scripts = [...container.querySelectorAll("script")];

    scripts.forEach((old) => {
      const s = document.createElement("script");

      [...old.attributes].forEach((attr) =>
        s.setAttribute(attr.name, attr.value),
      );

      if (old.src) {
        const already = [...document.scripts].some((x) => x.src === old.src);
        if (already) {
          old.remove();
          return;
        }
        s.src = old.src;
      } else {
        s.textContent = old.textContent;
      }

      old.parentNode.replaceChild(s, old);
    });
  }

  async function fetchProductHTML(handle) {
    const res = await fetch(getProductUrl(handle), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!res.ok) throw new Error(`product fetch failed: ${res.status}`);
    return res.text();
  }

  function getProductUrl(handle) {
    const m = window.location.pathname.match(/\/products\/([^\/]+)/);
    const currentHandle = m ? decodeURIComponent(m[1]) : null;

    // Cross-flavor swaps: load each product's own assigned template (beyond-brew-lp,
    // beyond-brew-lp-vanilla, pdp-cleanup, etc.) — not the source page's ?view= suffix.
    if (currentHandle && currentHandle !== handle) {
      return `/products/${handle}`;
    }

    const ctx = window.igData?.redirect?.getContext?.();
    const redirected = ctx?.template?.isRedirected;
    return redirected
      ? `/products/${handle}?view=${ctx.template.suffix}`
      : `/products/${handle}`;
  }

  function scrollToFlavorSelector() {
    const target =
      document.querySelector("[data-select-your-type]") ||
      document.querySelector("[data-select-your-type-block]") ||
      document.querySelector(".additional-flavors-dropdown-container__icons") ||
      document.getElementById("product-info-bottom");

    if (!target) return false;

    const y = target.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top: Math.max(0, y), left: 0, behavior: "auto" });
    return true;
  }

  function scrollToFlavorSelectorWithRetries() {
    // beyond-brew-lp / beyond-brew-lp-vanilla: hero + carousels need extra layout passes
    [0, 50, 150, 400, 800].forEach((ms) => {
      setTimeout(() => scrollToFlavorSelector(), ms);
    });
  }

  function destroySplideIn(container) {
    try {
      if (window.TW?.destroyTestimonialSplide) {
        window.TW.destroyTestimonialSplide(container);
        return;
      }
    } catch (e) {}

    try {
      container
        .querySelectorAll(".testimonial-carousel-slider")
        .forEach((el) => {
          if (el.__splide && typeof el.__splide.destroy === "function") {
            try {
              el.__splide.destroy(true);
            } catch (e) {}
            el.__splide = null;
          }
        });
    } catch (e) {}
  }

  function initSplideIn(container) {
    if (!window.Splide) return;

    try {
      if (window.TW?.initTestimonialSplide) {
        window.TW.initTestimonialSplide(container);
        return;
      }
    } catch (e) {}

    try {
      container
        .querySelectorAll(".testimonial-carousel-slider")
        .forEach((carousel) => {
          if (carousel.__splide) return;

          const parentSection = carousel.closest(
            ".testimonial-carousel-section",
          );
          if (!parentSection) return;

          const autoplay =
            parentSection.getAttribute("data-autoplay") === "true";
          const autoplaySpeed =
            parseInt(parentSection.getAttribute("data-autoplay-speed"), 10) ||
            5000;
          const desktopSlides =
            parseInt(parentSection.getAttribute("data-desktop-slides"), 10) ||
            1;

          const splide = new Splide(carousel, {
            type: "loop",
            perPage: desktopSlides,
            perMove: 1,
            autoplay,
            interval: autoplaySpeed,
            pagination: true,
            arrows: true,
            speed: 600,
            gap: 20,
            focus: "center",
            breakpoints: {
              767: { perPage: 1, gap: 0 },
            },
          });

          splide.mount();
          carousel.__splide = splide;
        });
    } catch (e) {}
  }

  function nextFrame() {
    return new Promise((r) =>
      requestAnimationFrame(() => requestAnimationFrame(r)),
    );
  }

  async function collapseTypeBeforeSwap(fromEl) {
    try {
      const api = window.SelectYourTypeCollapse;
      if (api?.collapse) await api.collapse({ fromEl });
    } catch (e) {}
  }

  async function expandTypeAfterSwap(fromEl) {
    try {
      const api = window.SelectYourTypeCollapse;
      if (api?.expand) await api.expand({ fromEl });
    } catch (e) {}
  }

  function pickClosest(root, fromEl, selector) {
    if (!root) return null;
    const list = [...root.querySelectorAll(selector)];
    if (list.length === 0) return null;
    if (!fromEl) return list[0];

    const from = fromEl.getBoundingClientRect();
    let best = list[0];
    let bestScore = Infinity;

    for (const el of list) {
      const r = el.getBoundingClientRect();
      const dy = Math.abs(r.top - from.top);
      const dx = Math.abs(r.left - from.left);
      const score = dy * 1000 + dx; // prioritize vertical proximity
      if (score < bestScore) {
        bestScore = score;
        best = el;
      }
    }

    return best;
  }

  async function swapSelectorsOnly(handle, clickedEl) {
    const scope = clickedEl?.closest("#MainContent") || document;
    const clickedCollagen = clickedEl?.closest("[data-select-your-collagen]");
    const currentCollagen =
      clickedCollagen || scope.querySelector("[data-select-your-collagen]");
    const currentTypeBlock =
      pickClosest(scope, currentCollagen, "[data-select-your-type-block]") ||
      pickClosest(scope, currentCollagen, "[data-select-your-type]");

    // If selectors aren't present, fall back to full swap.
    if (!currentTypeBlock) return swapProduct(handle, null, clickedEl);

    // Clicking within the collagen row should not replace the whole page.
    await collapseTypeBeforeSwap(clickedEl);

    const html = await fetchProductHTML(handle);
    const doc = docFrom(html);

    const incomingScope = doc.querySelector("#MainContent") || doc;
    const incomingCollagen = incomingScope.querySelector(
      "[data-select-your-collagen]",
    );
    const incomingTypeBlock =
      pickClosest(
        incomingScope,
        incomingCollagen,
        "[data-select-your-type-block]",
      ) ||
      pickClosest(incomingScope, incomingCollagen, "[data-select-your-type]");
    if (!incomingTypeBlock) return swapProduct(handle, null, clickedEl);

    if (currentCollagen && incomingCollagen) {
      currentCollagen.outerHTML = incomingCollagen.outerHTML;
    }

    currentTypeBlock.outerHTML = incomingTypeBlock.outerHTML;

    // Ensure the clicked collagen option is the only active one (prevents stale "active" state
    // from making the wrong option unclickable after a selector-only swap).
    try {
      const newCollagen =
        pickClosest(scope, currentTypeBlock, "[data-select-your-collagen]") ||
        scope.querySelector("[data-select-your-collagen]");
      if (newCollagen) {
        newCollagen
          .querySelectorAll(".select-your-x-item-anchor.is-active")
          .forEach((a) => {
            a.classList.remove("is-active");
            a.removeAttribute("aria-current");
          });
        const active = newCollagen.querySelector(
          `.select-your-x-item-anchor[data-handle="${CSS.escape(handle)}"]`,
        );
        if (active) {
          active.classList.add("is-active");
          active.setAttribute("aria-current", "page");
        }
      }
    } catch (e) {}

    const newTypeBlock =
      pickClosest(scope, currentCollagen, "[data-select-your-type-block]") ||
      pickClosest(scope, currentCollagen, "[data-select-your-type]");
    if (newTypeBlock) runScripts(newTypeBlock);

    await expandTypeAfterSwap(clickedEl);
  }

  async function swapProduct(handle, href, clickedEl) {
    const main = document.querySelector("#MainContent");
    if (!main) throw new Error("Could not find #MainContent.");

    // ✅ CHANGE: animate Type selector when clicking the "Select Your X" row (collagen),
    // not when clicking the Type options.
    const clickedInCollagen = !!clickedEl?.closest(
      "[data-select-your-collagen]",
    );
    if (clickedInCollagen) {
      await collapseTypeBeforeSwap(clickedEl);
    }

    destroySplideIn(main);

    const html = await fetchProductHTML(handle);
    const doc = docFrom(html);

    const incomingMain = doc.querySelector("#MainContent");
    if (!incomingMain) throw new Error("Incoming #MainContent not found.");

    main.innerHTML = incomingMain.innerHTML;

    // Update URL first so inline scripts that read location see the new handle.
    history.replaceState({ handle }, "", href || `/products/${handle}`);

    runScripts(main);
    reinitYotpo({ handle });

    await nextFrame();
    scrollToFlavorSelectorWithRetries();

    initSplideIn(main);

    if (window.Shopify?.PaymentButton) window.Shopify.PaymentButton.init();
    document.dispatchEvent(
      new CustomEvent("pdp:swapped", { detail: { handle } }),
    );

    if (clickedInCollagen) {
      await expandTypeAfterSwap(clickedEl);
    }

    function reinitYotpo(detail) {
      try {
        if (window.yotpo) {
          if (typeof window.yotpo.initWidgets === "function")
            window.yotpo.initWidgets();
          if (typeof window.yotpo.refreshWidgets === "function")
            window.yotpo.refreshWidgets();
        }
        if (
          window.Yotpo?.widgets &&
          typeof window.Yotpo.widgets.refresh === "function"
        ) {
          window.Yotpo.widgets.refresh();
        }
        document.dispatchEvent(new CustomEvent("yotpo:refresh", { detail }));
      } catch (e) {
        console.warn("Yotpo reinit failed", e);
      }
    }
  }

  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest(
        "a.select__list--icons-item-anchor, a.select-your-x-item-anchor",
      );
      if (!a) return;

      if (a.classList.contains("is-active")) {
        e.preventDefault();
        e.stopPropagation();
        if (a.classList.contains("select__list--icons-item-anchor")) {
          scrollToFlavorSelectorWithRetries();
        }
        return;
      }

      if (
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey ||
        e.altKey ||
        a.target === "_blank"
      )
        return;

      const handle = a.dataset.handle;
      if (!handle) return;

      e.preventDefault();
      e.stopPropagation();

      const isCollagenSwitch = a.classList.contains(
        "select-your-x-item-anchor",
      );
      const action = isCollagenSwitch
        ? swapSelectorsOnly(handle, a)
        : swapProduct(handle, a.href, a);

      Promise.resolve(action).catch((err) => {
        console.error(err);
        window.location.href = a.href;
      });
    },
    true,
  );

  // PDP rating strip: survives AJAX swaps (inline onclick / product.js only bind first paint).
  document.addEventListener(
    "click",
    (e) => {
      const strip = e.target.closest(
        "#MainContent #product .yotpo-reviews-container",
      );
      if (!strip) return;

      const reviewSection = document.getElementById("yotpo-reviews-main-widget");
      if (!reviewSection) return;

      reviewSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    true,
  );
})();
